import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {User, UsersQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL

const getUsers = (query: string): Promise<UsersQueryResponse> => {
  return axios
     .get(`${API_URL}/authenticate/getUsers?${query}`)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getUserById = (id: ID): Promise<User | undefined> => {
    var user = axios
        .get(`${API_URL}/authenticate/user/${id}`)
        .then((response: AxiosResponse<User>) => response.data)
    return user
}

const createUser = (user: User): Promise<User | undefined> => {
  return axios.post(`${API_URL}/authenticate/createUser`, user).then((response: Response<User>) => response.data)
}

const updateUser = (user: User): Promise<User | undefined> => {
  return axios.post(`${API_URL}/authenticate/user/${user.id}`, user)
}

const deleteUser = (userId: ID): Promise<void> => {
  return axios.delete(`${API_URL}/authenticate/user/${userId}`).then(() => {})
}

const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${API_URL}/authenticate/user/${id}`))
  return axios.all(requests).then(() => {})
}

export {getUsers, deleteUser, deleteSelectedUsers, getUserById, createUser, updateUser}
